import { Directive, HostBinding, HostListener } from '@angular/core';

@Directive({
  selector: '[appFocusWithin]',
})
export class FocusWithinDirective {
  @HostBinding('class.focus-within') isFocused: boolean;

  @HostListener('focusin')
  onFocusin() {
    this.isFocused = true;
  }

  @HostListener('focusout')
  onFocusout() {
    this.isFocused = false;
  }
}
